import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { StyledContributorsView } from './ContributorsView/ContributorsView.style';
import { StyledTeamsPicker } from './TeamsPicker/TeamsPicker.style';

export const StyledColumnHeader = styled.header`
  background-color: ${getColor('titanWhite')};
  color: ${getColor('shuttleGray')};
  padding: 0.5rem;
  position: relative;
  & svg#Close {
    position: absolute;
    right: 0.5rem;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`;

export const StyledSyncGitTeamsForm = styled.div`
  height: 100%;
  & .teams-form {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    width: 100%;
    height: 75%;

    & ${StyledTeamsPicker} {
      width: 100%;
      border: 1px solid ${getColor('catskillWhite')};
    }
    & ${StyledContributorsView} {
      border: 1px solid ${getColor('catskillWhite')};
      width: 30%;
    }
  }
`;
